export const TEXT_VIEW_DEFAULT_TEXT = '# Text';
